import { createSelector } from 'reselect';
import get from 'lodash/get';
import { SCOPE } from './types';

const selector = state => state[SCOPE];

export default selector;

export const searchSelector = createSelector(
  selector,
  (store) => {
    const search = get(store, 'location.search');
    if (!search || typeof search !== 'string') {
      return {};
    }
    const splitSearch = search.replace('?', '').split('&');
    return splitSearch.reduce((query, current) => {
      const mirrorQuery = query;
      const [field, value] = current.split('=');
      mirrorQuery[field] = value;
      return mirrorQuery;
    }, {});
  },
);

export const stateSelector = createSelector(
  selector,
  store => get(store, 'location.state', {}),
);

export const locationSelector = createSelector(
  selector,
  searchSelector,
  stateSelector,
  (store, searchStore, stateStore) => ({
    hash: get(store, 'location.hash', ''),
    key: get(store, 'location.key', ''),
    pathname: get(store, 'location.pathname', ''),
    search: searchStore,
    state: stateStore,
  }),
);
